module.exports = __webpack_public_path__ + "img/28.4b32f97.png";